import { render, staticRenderFns } from "./dormStuView.vue?vue&type=template&id=6a3bfc4a&"
import script from "./dormStuView.vue?vue&type=script&lang=js&"
export * from "./dormStuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports